import React, { useState } from "react";
import { useParams } from "react-router-dom";
import HubLayout from "../Layout";
import HubHeader from "../Layout/topHeader";
import OrderList from "../../Order";
import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useSelector } from "react-redux";

const HubOrderList = ({ params }: any) => {
  const { hubInfo } = useSelector((state) => (state as any)?.authReducer);
  const [activeSearch, setActiveSearch] = useState(false);

  return (
    <React.Fragment>
      <HubLayout hubId={hubInfo?.id}>
        <div className="product-list-item-area white-bg p-0">
          <HubHeader
            leftarea={"Order List"}
            rightarea={
              <>
                {activeSearch ? (
                  <Button
                    type="text"
                    danger
                    onClick={() => {
                      setActiveSearch(false);
                    }}
                    className="mr-2"
                  >
                    <ZoomOutOutlined />
                  </Button>
                ) : (
                  <Button
                    type="text"
                    onClick={() => {
                      setActiveSearch(true);
                    }}
                    className="mr-2"
                  >
                    <ZoomInOutlined />
                  </Button>
                )}
              </>
            }
          />
          <OrderList
            gethubId={hubInfo?.id}
            inHub={true}
            activeSearch={activeSearch}
          />
        </div>
      </HubLayout>
    </React.Fragment>
  );
};

export default HubOrderList;
